import { render, staticRenderFns } from "./AddProductDefault.vue?vue&type=template&id=8bc9c9d0&scoped=true"
import script from "./AddProductDefault.vue?vue&type=script&lang=js"
export * from "./AddProductDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc9c9d0",
  null
  
)

export default component.exports